import Chip from "./Chip";

const BoardNoneItem = () => {
    return (
        <div className="flex-1-1 border border-color-black rounded rounded-small padding-10" style={{background: '#E5EBF0', height: 184, borderColor: '#344054'}}>
            <div className="display-flex justify-content-between padding-bottom-4">
                <span className="text-medium text-size-14">-</span>
                <span>-</span>
            </div>
            <div className="display-flex flex-column margin-top-4 gap-4">
                <div className="display-flex justify-content-between">
                    <span className="text-size-14 line-height-20">-</span>
                    <span className="text-size-14 line-height-20">-</span>
                </div>
                <div className="display-flex justify-content-between">
                    <span className="text-size-14">-</span>
                    <span className="text-size-14">-</span>
                </div>
                <div className="display-flex justify-content-between width-100pct align-items-center justify-content-center rounded rounded-large" style={{background: '#F6F6F666', opacity: 1, height: 22}}>
                    <span>-</span>
                </div>
                <div className="display-flex justify-content-between">
                    <span className="text-size-14 line-height-20"></span>
                    <span className="text-size-14 line-height-20"></span>
                </div>
                <div className="display-flex gap-5">
                    
                </div>
            </div>
        </div>
    )
};

export default BoardNoneItem;